export const nonEmptyStr = /^(?!\s*$).+/;
